// ------------------- Utility -------------------
function createFocusOutHandler(button, popoverId) {
    return function focusOutsideHandler(e) {
        const popoverEl = document.getElementById(popoverId);
        if (!popoverEl) return;

        const isInPopover = popoverEl.contains(e.target);
        const isTrashButton = button.contains(e.target);

        if (!isInPopover && !isTrashButton) {
            $(button).popover('hide');
            document.removeEventListener('focusin', focusOutsideHandler);
        }
    };
}

// Add the trapFocus function
function trapFocus(modal) {
    const focusableSelectors = 'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
        'textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"])';

    const focusableElements = modal.querySelectorAll(focusableSelectors);
    if (focusableElements.length === 0) return;

    const firstEl = focusableElements[0];
    const lastEl = focusableElements[focusableElements.length - 1];

    modal.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === firstEl) {
                e.preventDefault();
                lastEl.focus();
            } else if (document.activeElement === lastEl) {
                e.preventDefault();
                firstEl.focus();
            }
        }
        if (e.key === 'Escape') {
            $(modal).modal('hide');
        }
    });
}

// ------------------- Popover Init -------------------
$(window).load(function () {
    // Enable keyboard support for trash buttons
    $(document).on('keydown', '.popover__btn', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).click();
        }
    });

    // popover template
    var popoverTemplateOrigin = [
        '<div  class="popover--delete popover">',
            '<div class="arrow"></div>',
            '<div class="container-fluid">',
                '<div class="row mt10--xs mt10--sm">',
                    '<div class="col-xs-20">',
                        '<div class="popover-content fs13--xs fs16--sm">',
                        '</div>',
                    '</div>',
                '</div>',
                '<div class="row mt10--xs mt10--sm mb10--xs mb10--sm">',
                    '<div class="col-xs-20">',
                        '<div class="popover-action fs13--xs fs16--sm">',
                            '<button class="btn btn--primary btn--delete" data-buy_remove_inner_anchor data-jentis_buy_cart_remove_{{article_type}}={{productId}} article_type={{productType}} data-remove_additional_shortnames={{mainRelatedArticles}} >',
                                '<i class="icon-trash" aria-hidden="true"></i>',
                                '<span class="popover-title fs13--xs fs16--sm">',
                                '</span>',
                            '</button>',
                        '</div>',
                    '</div>',
                '</div>',
            '</div>',
        '</div>'].join('');

    // functionality for each popover
    $('.popover__btn[data-target]').each(function (index, element) {
        var button               = this,
            activateOutsideClick = false,
            popupHovered         = false,
            hasEvents            = false,
            openPopup            = false,
            article_type         = $(element).attr('data-buy_remove_from_cart_dimension9'),
            productId            = $(element).attr('data-buy_remove_from_cart'),
            mainRelatedArticles  = $(element).attr('data-remove_additional_shortnames'),
            popoverTemplate      = popoverTemplateOrigin.replace("{{article_type}}", article_type).replace("{{productId}}", productId).replace("{{productType}}", article_type).replace("{{mainRelatedArticles}}", mainRelatedArticles);

        $(button).popover({
            'container': this,
            'template': popoverTemplate
        }).on('click', function() {
            // avoid double clicks with body.click
            if (!popupHovered) {
                activateOutsideClick = !activateOutsideClick;

                if (!openPopup) {
                    $(button).popover('show');
                } else {
                    $(button).popover('hide');
                    openPopup = false;
                }
            }
        }).on('shown.bs.popover', function () {
            activateOutsideClick = true;
            openPopup            = true;

            var deleteUrl   = $(button).attr('data-target'),
                popoverId   = $(this).attr('aria-describedby'),
                thisPopover = $('#' + popoverId);

                // Add accessible attributes
                const popoverIdAttr = 'accessible-popover-' + popoverId;
                const popoverText = thisPopover.find('.popover-content');
                const confirmButton = thisPopover.find('.btn--delete');
                const confirmLabel = thisPopover.find('.popover-title');

                // Assign IDs for ARIA
                popoverText.attr('id', popoverIdAttr + '-text');
                confirmLabel.attr('id', popoverIdAttr + '-label');
                thisPopover.attr('tabindex', '-1');

                thisPopover.attr({
                    role: 'dialog',
                    'aria-modal': 'true',
                    'aria-labelledby': popoverIdAttr + '-label',
                    'aria-describedby': popoverIdAttr + '-text'
                });

                // Move focus to the confirm button
                thisPopover.focus();


                // Reattach focusin listener every time popover opens
                const focusHandler = createFocusOutHandler(button, popoverId);
                document.addEventListener('focusin', focusHandler);

                // Clean up on hide
                $(button).on('hidden.bs.popover', function () {
                    document.removeEventListener('focusin', focusHandler);
                });


            if (!hasEvents) { // prevents from binding multiple times events
                thisPopover.find('.btn--delete').on('click', function () {
                    activateOutsideClick = false;
                    $(button).popover('toggle');
                    window.location.href = deleteUrl;
                });

                thisPopover.on('mouseenter', function() {
                    activateOutsideClick = false;
                    popupHovered         = false;
                }).on('mouseleave', function() {
                    activateOutsideClick = true;
                    popupHovered         = true;
                });

                $("body").on('click', function() {
                    if (!openPopup) {
                        return;
                    }
                    if (popupHovered) {
                        if (activateOutsideClick) {
                            $(button).popover('hide');
                            activateOutsideClick = false;
                            popupHovered         = false;
                            openPopup            = false;
                        }
                    } else {
                        if (openPopup && activateOutsideClick) {
                            $(button).popover('hide');
                            activateOutsideClick = false;
                            popupHovered         = false;
                            openPopup            = false;
                        }
                    }
                });
                hasEvents = true;
            }
        });
    });
});

// ------------------- XS Modal Support -------------------

// Enable keyboard support for dynamically created delete buttons
$(document).on('keydown', '.btn--delete', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).click();
    }
});

$(document).on('keydown', '.trash-btn-xs', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).click();
    }
});

// for xs view
$(document).on('click', '.trash-btn-xs', function () {
    const deleteUrl = $(this).data('deleteurl');
    const hasIncl = $(this).data('hasincl');
    const buyRemoveFromCart = $(this).data('buy_remove_from_cart');
    const dataRemoveAdditionalShortnames = $(this).data('remove_additional_shortnames');
    const buyRemoveFromCartDimension9 = $(this).data('buy_remove_from_cart_dimension9');
    const modalId = hasIncl ? '#modalDelMainArticle' : '#modalDelMainArticleNoIncl';
    
    const modalButton = $(modalId).find('[data-buy_remove_inner_anchor]');
    modalButton.data('deleteurl', deleteUrl);
    modalButton.attr('data-buy_remove_from_cart_dimension9', buyRemoveFromCartDimension9 || '');
    modalButton.attr('data-remove_additional_shortnames', dataRemoveAdditionalShortnames || '');
    
    // Set dynamic jentis tracking attribute based on dimension type
    if (buyRemoveFromCartDimension9 === 'main') {
        modalButton.attr('data-jentis_buy_cart_remove_main', buyRemoveFromCart || '');
        modalButton.removeAttr('data-jentis_buy_cart_remove_additional');
    } else if (buyRemoveFromCartDimension9 === 'additional') {
        modalButton.attr('data-jentis_buy_cart_remove_additional', buyRemoveFromCart || '');
        modalButton.removeAttr('data-jentis_buy_cart_remove_main');
    }
    
    $(modalId).modal('show');
});

$(document).on('click keydown', '[data-buy_remove_inner_anchor]', function (e) {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const deleteUrl = $(this).data('deleteurl');
        if (deleteUrl) {
            window.location.href = deleteUrl;
        }
    }
});

// Handle NO (cancel) button in modal
$(document).on('click', '[data-modalDecision="false"]', function () {
    $(this).closest('.modal').modal('hide');
});

// ------------------- Focus on Modal Open -------------------
$('.modal').on('shown.bs.modal', function () {
    const modal = this;

    // Focus close button first
    const closeButton = modal.querySelector('.close');
    if (closeButton) {
            closeButton.focus();
        }

        // Trap focus inside modal
        trapFocus(modal);
});

